<app-work-detail-select-user
    #selectDoctor
    [serviceId]="serviceId"
    [employments]="[EmploymentEnum.DOCTOR]"
    (selectedUser)="form.patchValue({ userId: $event })"
></app-work-detail-select-user>

@if(secretType === UserSecretTypeEnum.QUAL_CERT) {
    <h4>{{ 'service.settings.eprescriptions.addQualCertificate' | translate }}</h4>
    <app-user-upload-certificate [userId]="form.get('userId')?.value ?? null"></app-user-upload-certificate>
}
@if(secretType === UserSecretTypeEnum.SUKL_IDENTITY) {
    <h4>{{ 'service.settings.eprescriptions.addSuklIdentity' | translate }}</h4>
    <app-user-upload-secret [userId]="form.get('userId')?.value ?? null"></app-user-upload-secret>

}
